import React from "react";
import { Pagination } from "antd";

import { useSearchResults } from "../../data/useSearchResults";
import { PAGE_PARAM_KEY } from "../../utils/constants";
import { PaginationContainer } from "./styles";

const SearchPagination = () => {
  const { page, setPage, resultsData, updatePathQuery } = useSearchResults();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const pageQuery = urlParams.get(PAGE_PARAM_KEY);
  const currentPage = pageQuery ? Number(pageQuery) : page;

  const onChange = (page) => {
    updatePathQuery({ page });
    setPage(page);
  };

  return (
    <PaginationContainer>
      {resultsData?.meta?.pages_count > 1 && (
        <Pagination
          current={currentPage}
          defaultPageSize={24}
          onChange={onChange}
          pageSize={resultsData?.meta?.pages_items}
          showSizeChanger={false}
          total={
            resultsData?.meta?.filters_results_count ??
            resultsData?.meta?.results_count
          }
        />
      )}
    </PaginationContainer>
  );
};

export default SearchPagination;
